'use client';

import banner1 from '@/assets/images/convention/affiliate/Affiliate.jpg';
import banner1_m from '@/assets/images/convention/affiliate/Affiliate_m.jpg';
import useIsMobile from '@/hooks/use-is-mobile';
import Image from 'next/image';
import classes from './affiliateProgram.module.css';

export const AffiliateProgram = () => {
  const pageTitle = 'AFFILIATE PROGRAM';

  const isMobile = useIsMobile();

  return (
    <div className={classes.affiliate}>
      <Image
        className={classes.bannerimg}
        src={isMobile ? banner1_m : banner1}
        alt=''
      />
      <h1 className={classes.title}>{pageTitle}</h1>
      <div className={classes.conent}>
        <h3 className={classes.subtitle}>Join the AW.Bridal Family by Becoming an Affiliate!</h3>
        <p className={classes.thirdlytitle}>
          Start earning commissions by partnering with AW.Bridal to share our affordable bridal products with your
          visitors!
        </p>
        <hr className={classes.hr} />
        <p>Why join our affiliate program?</p>
        <ul className={classes.reasonslist}>
          <li className={classes.reasons}>8% commission per order</li>
          <li className={classes.reasons}>90-day cookie tracking</li>
          <li className={classes.reasons}>Free customized dresses and a variety of affordable products</li>
          <li className={classes.reasons}>Professional selection of creative banners and text links</li>
        </ul>
        <p>
          To join, create a&nbsp;
          <a
            className={classes.link}
            href='https://account.shareasale.com/m-login.cfm?invalid=1&reason=1&redirect=%2Fm%2Dmain%2Ecfm?%26itpStatus%3D4'
            target='_blank'
          >
            ShareASale
          </a>
          &nbsp;account first. If you already have one, click&nbsp;
          <a
            className={classes.link}
            href='https://account.shareasale.com/m-affiliates.cfm'
            rel='nofollow'
            target='_blank'
          >
            here
          </a>
          &nbsp;to join!
        </p>
        <p>
          If you have any questions, please contact us at{' '}
          <a
            className={classes.link}
            rel='nofollow'
            target='_blank'
            href='mailto:someone@yoursite.com'
          >
            Affiliate@awbridal.com
          </a>
          .
        </p>
      </div>
    </div>
  );
};

export default AffiliateProgram;
